(() => {
  if (window.imageBannerSectionScrollReady) return;
  window.imageBannerSectionScrollReady = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element
      ? event.target.closest('[data-image-banner-scroll]')
      : null;
    if (!trigger) return;

    event.preventDefault();

    const sectionsToSkip = Number.parseInt(trigger.dataset.imageBannerScroll, 10);
    const currentSection = trigger.closest('.shopify-section');
    if (!currentSection || sectionsToSkip < 1 || sectionsToSkip > 4) return;

    let targetSection = currentSection;
    for (let index = 0; index < sectionsToSkip; index += 1) {
      targetSection = targetSection.nextElementSibling;
      while (targetSection && !targetSection.classList.contains('shopify-section')) {
        targetSection = targetSection.nextElementSibling;
      }
      if (!targetSection) return;
    }

    const targetTop = targetSection.getBoundingClientRect().top + window.scrollY;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: targetTop, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
})();
